const toUtcDate = value => {
  if (typeof value !== 'string') return null
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  if (!match) return null
  return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])))
}

const addDays = (date, days) => {
  const result = new Date(date)
  result.setUTCDate(result.getUTCDate() + days)
  return result
}

const getDutchHolidays = year => {
  const a = year % 19
  const b = Math.floor(year / 100)
  const c = year % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const month = Math.floor((h + l - 7 * m + 114) / 31)
  const day = ((h + l - 7 * m + 114) % 31) + 1
  const easter = new Date(Date.UTC(year, month - 1, day))
  const iso = date => date.toISOString().slice(0, 10)
  const april27 = new Date(Date.UTC(year, 3, 27))
  const kingsDay = april27.getUTCDay() === 0 ? addDays(april27, -1) : april27

  return new Set([
    iso(new Date(Date.UTC(year, 0, 1))),
    iso(addDays(easter, 1)),
    iso(kingsDay),
    iso(addDays(easter, 39)),
    iso(addDays(easter, 50)),
    iso(new Date(Date.UTC(year, 11, 25))),
    iso(new Date(Date.UTC(year, 11, 26)))
  ])
}

/** Count effective Dutch working days in an inclusive date range. */
export function countWorkingDays(startDate, endDate) {
  const start = toUtcDate(startDate)
  const end = toUtcDate(endDate)
  if (!start || !end || start > end) return 0

  const holidaysByYear = new Map()
  let count = 0
  for (const date = new Date(start); date <= end; date.setUTCDate(date.getUTCDate() + 1)) {
    const day = date.getUTCDay()
    if (day === 0 || day === 6) continue

    const year = date.getUTCFullYear()
    if (!holidaysByYear.has(year)) holidaysByYear.set(year, getDutchHolidays(year))
    if (holidaysByYear.get(year).has(date.toISOString().slice(0, 10))) continue
    count += 1
  }
  return count
}
